import { User } from "../../generated/graphql";

export const mapUsers = (users: User[]) => users?.map(({
  firstName,
  lastName,
  phone,
  email,
  birthday,
  role: { displayName }
}) => ({
  firstName,
  lastName,
  email,
  phone,
  birthday,
  role: displayName,
}));
